export const USER_TOKEN = "mark-lms-user";
